import { Suspense, useState } from "react";
import { cn } from "@/lib/utils";
import { Spinner } from "@/lib/Components/Layout/Loaders/Spinner";
import { useTripRecord } from "@/app/Cities/Trips/Hooks/useTripRecord";
import { TripArticleManager } from "@/app/Cities/Trips/Components/TripArticleManager";

export function TripArticlesScreen() {
  const trip = useTripRecord();
  const directions = [
    { origin: trip.cityA, destination: trip.cityB },
    { origin: trip.cityB, destination: trip.cityA },
  ];
  const [directionIndex, setDirectionIndex] = useState(0);
  const direction = directions[directionIndex];

  return (
    <div className="space-y-6 py-6">
      <div className="space-y-2">
        <div className="inline-flex rounded-lg bg-gray-100 p-1">
          {directions.map(({ origin, destination }, index) => (
            <button
              key={origin.id}
              type="button"
              aria-pressed={index === directionIndex}
              onClick={() => setDirectionIndex(index)}
              className={cn(
                "rounded-md px-3 py-1.5 text-sm font-medium transition-colors",
                index === directionIndex
                  ? "bg-white text-gray-900 shadow-sm"
                  : "text-gray-500 hover:text-gray-700",
              )}
            >
              {origin.name} → {destination.name}
            </button>
          ))}
        </div>
        <p className="text-sm text-gray-500">
          Linked articles show in the &ldquo;Plan your road trip&rdquo; section
          of the {direction.origin.name} to {direction.destination.name} deal
          pages. Each direction has its own list.
        </p>
      </div>

      <Suspense
        fallback={
          <div className="flex justify-center py-6">
            <Spinner className="size-5" />
          </div>
        }
      >
        <TripArticleManager
          key={direction.origin.id}
          originCityId={direction.origin.id}
          destinationCityId={direction.destination.id}
        />
      </Suspense>
    </div>
  );
}
